import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Button, MaterialPalette, Typography } from '@nutrien/cxp-components';
import React from 'react';

const useStyles = makeStyles({
  gridStyle: {
    padding: '8px',
    width: 'fit-content',
    '& .buttonStyle': {
      borderRadius: '4px',
      '&:disabled': {
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
      },
    },
  },
  buttonText: {
    letterSpacing: 1.25,
    color: MaterialPalette.common.black,
  },
});

interface Props {
  buttonText: string;
  onClose: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  ErrorColor?: boolean;
  dataTestId?: string;
  gridStyle?: string;
}

const CustomButton: React.FC<Props> = ({
  buttonText,
  onClose,
  disabled = false,
  isLoading = false,
  ErrorColor = false,
  dataTestId = 'customButton',
  gridStyle,
}) => {
  const classes = useStyles({ disabled });

  return (
    <Grid container justifyContent="flex-end" className={`${gridStyle} ${classes.gridStyle}`}>
      <Button
        variant="contained"
        color={ErrorColor ? 'error' : 'primary'}
        noMinHeight
        onClick={onClose}
        disabled={disabled}
        isLoading={isLoading}
        className="buttonStyle"
        data-testid={dataTestId}
      >
        <Typography className={classes.buttonText} fontWeight={700}>
          {buttonText}
        </Typography>
      </Button>
    </Grid>
  );
};

export default CustomButton;
